import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Device } from '../../../../play-core/styles/Device';
import { Fonts } from '../../../../play-core/styles/Fonts';
export const HistogramEmptyEntry = styled.li.withConfig({
  displayName: "HistogramEntrystyles__HistogramEmptyEntry",
  componentId: "sc-57lvgr-0"
})(["border-left:2px solid ", ";border-right:2px solid ", ";height:", "%;width:6px;background:", ";transition:height 0.5s ease-in-out;"], Colors.GREY_1a1a1a, Colors.GREY_1a1a1a, ({
  height
}) => height, Colors.GREY_515151);
export const Tooltip = styled.div.withConfig({
  displayName: "HistogramEntrystyles__Tooltip",
  componentId: "sc-57lvgr-1"
})(["pointer-events:none;position:absolute;display:flex;opacity:0;flex-direction:column;width:70px;padding:2px;border-radius:2px;align-items:center;color:", ";background-color:", ";margin:0 auto;transform:translate(-50%,-50%);top:calc(100% + 35px);transition:opacity 300ms ease-in-out;z-index:1;"], Colors.GREY_222222, Colors.GREY_d2d2d2);
export const TooltipCount = styled.span.withConfig({
  displayName: "HistogramEntrystyles__TooltipCount",
  componentId: "sc-57lvgr-2"
})(["", ";"], Fonts.medium(14));
export const TooltipTime = styled.span.withConfig({
  displayName: "HistogramEntrystyles__TooltipTime",
  componentId: "sc-57lvgr-3"
})(["", ";"], Fonts.regular(12));
export const TooltipArrow = styled.span.withConfig({
  displayName: "HistogramEntrystyles__TooltipArrow",
  componentId: "sc-57lvgr-4"
})(["position:absolute;top:-7px;width:0;height:0;border-left:8px solid transparent;border-right:8px solid transparent;border-bottom:8px solid ", ";"], Colors.GREY_d2d2d2);
export const HistogramDefaultEntry = styled(HistogramEmptyEntry).withConfig({
  displayName: "HistogramEntrystyles__HistogramDefaultEntry",
  componentId: "sc-57lvgr-5"
})(["background:linear-gradient(180deg,", ",", ");cursor:pointer;position:relative;", "{&:hover{background:", ";", "{opacity:1;}}}"], Colors.BLUE_02D4ff, Colors.BLUE_0567FF, Device.mouse, Colors.GREY_aaaaaa, Tooltip);